import Form from 'react-bootstrap/Form';
import { useHistory, useLocation, useParams } from 'react-router-dom';
import { useEffect, useState, useRef } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import config from '../../config/config';
import axios from 'axios';
import { format } from 'date-fns';
import { useForm } from 'react-hook-form';

const AddUnits = (props) => {
  const { id } = useParams();
  let history = useHistory();
  const isAddMode = !id;
  const {
    register,
    reset,
    handleSubmit,
    setValue,
    watch,
    errors,
    formState,
  } = useForm();
  const [unit, setUnit] = useState([]);
  const [checked, setChecked] = useState(false);
  const { isValid } = useState([]);

  function onSubmit(data) {
    return isAddMode ? createUnit(data) : updateUnit(id, data);
  }
  function createUnit(data) {
    axios
      .post(`${config.postUrl}/unit`, data)
      .then((res) => {
        history.push('.');
      })
      .catch((error) => {});
  }
  function updateUnit(id, data) {
    const requestOptions = {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data),
    };
    fetch(`${config.putUrl}/unit/${id}`, requestOptions).then((res) => {
      history.push('..');
    });
  }



  useEffect(() => {
    if (!isAddMode) {
      var auth = auth;
      axios.get(`${config.getUrl}/unit/${id}`).then((brand) => {
        const fields = Object.keys(brand.data);
        fields.map((field) => setValue(field, brand.data[field]));
      });
    }
  }, []);
   

  return (
    <>
      <main className="box-sh p-3">
        <form onSubmit={handleSubmit(onSubmit)} onReset={reset}>
          {isAddMode ? '' : <input name="id" type="hidden" ref={register()} />}
          <h3 className="text-center mb-3">
            {isAddMode ? 'Add Units' : 'Add Units'}
          </h3>
          
          <div className="col-lg-12 d-flex justify-content-center">
            <div className="col-lg-6">
              <label>Unit</label>
              <input
                type="text"
                name="name"
                ref={register({ required: true })}
                className="form-control"
                placeholder="Unit Name"
              ></input>
              {errors.name && <span className="errorMessage">Pflichtfeld</span>}
            </div>
            </div>
            <div className="col-lg-12 mt-5 d-flex mt justify-content-center">
                <input type="submit" className="nav-link btn lpbgColor"></input>
            </div>
         
        </form>
      </main>
    </>
  );
};

export default AddUnits;
